import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const UpdateIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.9394 12.0859C15.0911 14.7475 12.6615 16.6693 9.79668 16.6693C6.22635 16.6693 3.33203 13.6845 3.33203 10.0026C3.33203 6.32071 6.22635 3.33594 9.79668 3.33594C11.8908 3.33594 13.7524 4.36281 14.9338 5.95493M15.3965 6.66927C15.257 6.42055 15.1023 6.18199 14.9338 5.95493M14.9338 5.95493L13.433 7.5026H16.6654V4.16927L14.9338 5.95493ZM15.0492 7.22483L16.0593 5.83594"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

UpdateIcon.displayName = 'UpdateIcon';
